<template>
    <div>
        <a-breadcrumb style="margin: 16px 0">
            <a-breadcrumb-item>
                <router-link :to="'/'">
                    Dashboard
                </router-link>
            </a-breadcrumb-item>
            <template v-if="manageMemberRoutes">
                <a-breadcrumb-item v-if="$route.name !== 'member-report'">
                    <router-link :to="'/manage-member/list'">
                        Member List
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'member-report'">
                    <router-link :to="'/manage-member/report-list'">
                        Member Reports
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="
                        $route.name === 'member-update' ||
                            $route.name === 'mutate-wallet' ||
                            $route.name === 'mutate-membership-chance' ||
                            $route.name === 'membership-rule-list'
                    "
                >
                    <router-link
                        :to="{
                            name: 'member-update',
                            params: { id: $route.params.id }
                        }"
                    >
                        Edit {{ $route.params.id }}
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'mutate-wallet'">
                    Mutate Wallet
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="$route.name === 'mutate-membership-chance'"
                >
                    Mutate Membership Chances
                </a-breadcrumb-item>
            </template>
            <template v-if="manageProfessionalRoutes">
                <a-breadcrumb-item
                    v-if="
                        $route.name === 'professional-list' ||
                            $route.name === 'professional-update'
                    "
                >
                    <router-link :to="'/manage-professional/list'">
                        Professional List
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'professional-update'">
                    <router-link
                        :to="{
                            name: 'professional-update',
                            params: { id: $route.params.id }
                        }"
                    >
                        Edit {{ $route.params.id }}
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="
                        $route.name === 'professional-verification-request' ||
                            $route.name === 'professional-verification-detail'
                    "
                >
                    <router-link
                        :to="'/manage-professional/verification-request'"
                    >
                        Verification Requests
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="$route.name === 'professional-verification-detail'"
                >
                    Detail {{ $route.params.id }}
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="
                        $route.name === 'direct-order-list' ||
                            $route.name === 'direct-order-track-progress' ||
                            $route.name === 'direct-order-complain-detail'
                    "
                >
                    <router-link :to="'/manage-professional/direct-order'">
                        DO & Complain
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="$route.name === 'direct-order-track-progress'"
                >
                    Track Progress #{{ $route.params.id }}
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="$route.name === 'direct-order-complain-detail'"
                >
                    Complain Detail #{{ $route.params.id }}
                </a-breadcrumb-item>
            </template>
            <template v-if="manageAdminRoutes">
                <a-breadcrumb-item>
                    <router-link :to="'/manage-admin/list'">
                        Admin List
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'admin-invite'">
                    Invite
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'admin-permission'">
                    Permission
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'admin-roles'">
                    Admin Role
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'activity-log'">
                    Activity Log
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'admin-update'">
                    Edit {{ $route.params.id }}
                </a-breadcrumb-item>
            </template>
            <template v-if="manageAdvertisementRoutes">
                <a-breadcrumb-item
                    v-if="$route.name === 'property-advertisement-list'"
                >
                    <router-link
                        :to="
                            '/manage-advertisement/property-advertisement-list'
                        "
                    >
                        Property Advertisement List
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="$route.name === 'project-advertisement-list'"
                >
                    <router-link
                        :to="'/manage-advertisement/project-advertisement-list'"
                    >
                        Project Advertisement List
                    </router-link>
                </a-breadcrumb-item>
            </template>
            <template v-if="manageCMSRoutes">
                <a-breadcrumb-item v-if="$route.name === 'compro'">
                    <router-link :to="'/manage-cms/compro'">
                        Company Profile Edit
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="
                        $route.name === 'our-team-list' ||
                            $route.name === 'our-team-create' ||
                            $route.name === 'our-team-update'
                    "
                >
                    <router-link :to="'/manage-cms/our-team-list'">
                        Our Team List
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'our-team-create'">
                    Create
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'our-team-update'">
                    Edit {{ $route.params.id }}
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'hiw-agent-referral'">
                    <router-link :to="'/manage-cms/hiw-agent-referral'">
                        HIW Agent & Referral Edit
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'hiw-crowdinvest'">
                    <router-link :to="'/manage-cms/hiw-crowdinvest'">
                        HIW Crowdinvest Edit
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'hiw-professional'">
                    <router-link :to="'/manage-cms/hiw-professional'">
                        HIW Professional Edit
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'faq'">
                    <router-link :to="'/manage-cms/faq'">
                        FAQ Edit
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'risk-and-warning'">
                    <router-link :to="'/manage-cms/risk-and-warning'">
                        Risk and Warning Edit
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'tnc'">
                    <router-link :to="'/manage-cms/tnc'">
                        Tnc Edit
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'cookie-policy'">
                    <router-link :to="'/manage-cms/cookie-policy'">
                        Cookie Policy Edit
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'privacy-policy'">
                    <router-link :to="'/manage-cms/privacy-policy'">
                        Privacy Policy Edit
                    </router-link>
                </a-breadcrumb-item>
            </template>
            <template v-if="manageCrowdfundRoutes">
                <a-breadcrumb-item v-if="$route.name === 'crowdfund-propose'">
                    Crowdfund Propose
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="
                        $route.name === 'crowdfund-list' ||
                            investorListFromCrowdfund ||
                            $route.name === 'investor-list' ||
                            $route.name === 'investment-history-list' ||
                            $route.name === 'broadcast-list'
                    "
                >
                    <router-link :to="'/manage-crowdfund/list'">
                        Crowdfund List
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'crowdfund-update'">
                    Crowdfund Edit {{ $route.params.id }}
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="
                        $route.name === 'investor-list' ||
                            $route.name === 'investment-history-list'
                    "
                >
                    <router-link
                        v-if="$route.name === 'investment-history-list'"
                        :to="'/manage-crowdfund/investors'"
                    >
                        Investors
                    </router-link>
                    <span v-else>Investors</span>
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="$route.name === 'investment-history-list'"
                >
                    Investment History
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'broadcast-list'">
                    Broadcasts
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'marketplace-list'">
                    <router-link :to="'/manage-crowdfund/marketplace-list'">
                        Marketplace List
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="$route.name === 'crowdfund-convert-request'"
                >
                    <router-link :to="'/manage-crowdfund/convert-request'">
                        Convert Request
                    </router-link>
                </a-breadcrumb-item>
            </template>
            <template v-if="manageMembershipRoutes">
                <a-breadcrumb-item>
                    <router-link :to="'/manage-membership/list'">
                        Membership List
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'membership-create'">
                    Create
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'membership-update'">
                    Edit {{ $route.params.id }}
                </a-breadcrumb-item>
            </template>
            <template v-if="manageOrderRoutes">
                <a-breadcrumb-item
                    v-if="$route.name === 'membership-order-list'"
                >
                    <router-link :to="'/manage-order/membership-order-list'">
                        Membership Order List
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="$route.name === 'topup-order-list'">
                    <router-link :to="'/manage-order/topup-order-list'">
                        Topup Order List
                    </router-link>
                </a-breadcrumb-item>
            </template>
            <template v-if="managePayoutRoutes">
                <a-breadcrumb-item>
                    Payout List
                </a-breadcrumb-item>
            </template>
            <template v-if="manageReferralRoutes">
                <a-breadcrumb-item>
                    <router-link :to="'/manage-referral/member-referral'">
                        Member Referral List
                    </router-link>
                </a-breadcrumb-item>
            </template>
            <template v-if="manageSettingRoutes">
                <a-breadcrumb-item
                    v-if="$route.name === 'internal-setting-update'"
                >
                    Internal Setting Update
                </a-breadcrumb-item>
                <a-breadcrumb-item
                    v-if="$route.name === 'consume-setting-update'"
                >
                    Consume Setting Update
                </a-breadcrumb-item>
            </template>
        </a-breadcrumb>
    </div>
</template>

<script>
export default {
    name: 'BreadcrumbCollection',
    computed: {
        manageMemberRoutes() {
            const path = this.$route.path;
            return (
                path.startsWith('/manage-member') &&
                !path.startsWith('/manage-membership')
            );
        },
        manageAdminRoutes() {
            return this.$route.path.startsWith('/manage-admin');
        },
        manageAdvertisementRoutes() {
            return this.$route.path.startsWith('/manage-advertisement');
        },
        manageCMSRoutes() {
            return this.$route.path.startsWith('/manage-cms');
        },
        manageCrowdfundRoutes() {
            return this.$route.path.startsWith('/manage-crowdfund');
        },
        investorListFromCrowdfund() {
            return (
                this.$route.params.crowdfundId &&
                this.$route.name === 'investor-list'
            );
        },
        manageMembershipRoutes() {
            return this.$route.path.startsWith('/manage-membership');
        },
        manageOrderRoutes() {
            return this.$route.path.startsWith('/manage-order');
        },
        managePayoutRoutes() {
            return this.$route.path.startsWith('/manage-payout');
        },
        manageReferralRoutes() {
            return this.$route.path.startsWith('/manage-referral');
        },
        manageSettingRoutes() {
            return this.$route.path.startsWith('/manage-setting');
        },
        manageProfessionalRoutes() {
            return this.$route.path.startsWith('/manage-professional');
        }
    }
};
</script>
